import { useMemo } from "react";

export function useAccrualMatchSummaryMap<TSummary>({
    summaries,
    getDocumentId,
}: {
    summaries: TSummary[] | undefined;
    getDocumentId: (summary: TSummary) => string;
}): Map<string, TSummary> {
    return useMemo(
        () =>
            new Map(
                summaries?.map((summary) => [getDocumentId(summary), summary]),
            ),
        [summaries, getDocumentId],
    );
}
